import React, { useEffect, useRef, useState, useCallback } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { NavLink } from '../lib/Navigation';
import general from '../general';

export default function Test() {
  const startXRef = useRef(null); // 存储触摸起始 X 坐标
  const swiperRef = useRef()
  const innerWidth = window.innerWidth > 720 ? 720 : window.innerWidth;
  const [swiperHeight, setSwiperHeight] = useState(innerWidth * 9 / 16); // 初始高度为16:9比例
  const [activeIndex, setActiveIndex] = useState(0)
  const imgs = [
    'https://static.app.985sy.com/admin-fast-system/gamedata/20250620/gamemap/fivepicf3ccdd27d2000e3f9255a7e3e2c488001750409627.jpg',
    'https://static.app.985sy.com/admin-fast-system/gamedata/20250620/gamemap/fivepic156005c5baf40ff51a327f1c34f2975b1750409628.jpg',
    'https://static.app.985sy.com/admin-fast-system/gamedata/20250620/gamemap/fivepic799bad5a3b514f096e69bbc4a7896cd91750409629.jpg',
    'https://static.app.985sy.com/admin-fast-system/gamedata/20250620/gamemap/fivepicd0096ec6c83575373e3a21d129ff8fef1750409630.jpg',
    'https://static.app.985sy.com/admin-fast-system/gamedata/20250620/gamemap/fivepic032b2cc936860b03048302d991c3498f1750409630.jpg',
  ]

  const items = imgs.map((img, index) => (
    <SwiperSlide className='aaa' style={{ width: '310px !important' }} key={index}>
      <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: 'black' }}>
        <img src={img} alt="" />
      </div>
    </SwiperSlide>
  ))

  const data = [
    { title: '宣传片', direction: 'horizontal', type: 'video', height: innerWidth * 9 / 16, src: 'https://static-cdn.app.wakaifu.com/admin-fast-system/gamedata/20250620/gamevideo/2025062016535493.mp4' },
    { title: '实机演示', direction: 'vertical', type: 'video', height: 512, src: 'https://static-cdn.app.wakaifu.com/admin-fast-system/gamedata/20250827/gamemachinevideo/2025082714033240.mp4' },
    { title: '介绍图', direction: 'vertical', type: 'image', height: 512 },
  ]

  useEffect(() => {
    setSwiperHeight(data[0].height)
  }, [])

  const handleTouchStart = (swiper, event) => {
    const touch = event.touches ? event.touches[0] : event;
    startXRef.current = touch.clientX; // 记录触摸开始的 X 坐标
  };

  const handleProgress = (swiper, progress) => {
    console.log('progress', progress, swiper.touches);

    if (progress < 0 || progress > 1) return; // 仅在有效范围内处理
    if (startXRef.current === null) return; // 确保有起始坐标

    const currentX = swiper.touches.currentX; // 当前触摸 X 坐标
    const activeIndex = swiper.activeIndex; // 当前激活的滑块索引    
    const targetItem = swiper.slides[activeIndex];
    const targetHeight = data[activeIndex].height;
    let newprogress = 0
    if (data.length == 2) {
      newprogress = progress
    } else if (data.length == 3) {
      newprogress = (progress - (activeIndex / (data.length - 1))) * 2
    }
    if (currentX < startXRef.current) {
      // console.log('左滑', '进度:', progress, '目标 item:', targetItem);
      const nextIndex = activeIndex + 1;
      if (nextIndex < data.length) {
        const nextItem = data[nextIndex];
        const nextHeight = nextItem.height;
        const nextHeightDiff = nextHeight - targetHeight;
        const newHeight = targetHeight + nextHeightDiff * newprogress;
        console.log('左滑newHeight', newHeight);
        setSwiperHeight(newHeight);
      }
    } else if (currentX > startXRef.current) {
      // console.log('右滑', '进度:', progress, '目标 item:', targetItem);
      const beforeIndex = activeIndex - 1;
      if (beforeIndex >= 0) {
        const beforeItem = data[beforeIndex];
        const beforeHeight = beforeItem.height;
        let newHeight = 0
        if (data.length == 2) {
          const beforeHeightDiff = targetHeight - beforeHeight;
          newHeight = beforeHeight + beforeHeightDiff * newprogress;
        } else if (data.length == 3) {
          const beforeHeightDiff = beforeHeight - targetHeight;
          newHeight = targetHeight - beforeHeightDiff * newprogress;
        }
        setSwiperHeight(newHeight);
        console.log('右滑newHeight', newHeight);

      }
    }
  };

  return (
    <div style={{ backgroundColor: '#f5f6f8' }}>
      <div style={{ backgroundColor: 'black' }}>
        <Swiper
          ref={swiperRef}
          style={{
            height: `${swiperHeight}px`,
          }}
          loop={false}
          spaceBetween={10}
          slidesPerView={'auto'}
          onSlideChange={swiper => {
            setActiveIndex(swiper.activeIndex)
          }}
          onTouchStart={handleTouchStart}
          onProgress={handleProgress}>
          {data.map((item, index) => {
            return (
              item.type === 'video' ?
                <SwiperSlide style={{ backgroundColor: 'black' }}>
                  <video
                    autoPlay muted playsInline controls
                    style={{
                      height: `${item.height}px`,
                      marginLeft: '50%',
                      transform: 'translateX(-50%)'
                    }}
                    src={item.src}></video>
                </SwiperSlide> :
                <SwiperSlide style={{ backgroundColor: 'black' }}>
                  <Swiper loop={false} spaceBetween={10} slidesPerView={'auto'}>
                    {items}
                  </Swiper>
                </SwiperSlide>
            )
          })}
        </Swiper>
        <div style={{
          backgroundColor: 'transparent',
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center',
          padding: '10px 0',
          position: 'relative',
          top: data[activeIndex].direction === 'vertical' ? '-34px' : '0',
          zIndex: '2'
        }}>
          {
            data.map((item, index) => (
              <div style={{
                color: activeIndex === index ? 'black' : 'white',
                backgroundColor: activeIndex === index ? 'white' : '#333',
                padding: '0px 10px',
                fontSize: '12px'
              }} key={index} onClick={() => {
                swiperRef.current.swiper.slideTo(index)
                setActiveIndex(index)
                setSwiperHeight(data[index].height)
              }}>{item.title}</div>
            ))
          }
        </div>
      </div>

      <div style={{
        position: 'relative',
        top: data[activeIndex].direction === 'vertical' ? '-34px' : '0',
        zIndex: '2',
        backgroundColor: 'white',
      }}>
        <NavLink user={false} to='/test'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit labore voluptas consequuntur, delectus vitae laborum iusto eum quaerat, ratione amet, autem voluptates quisquam eveniet. Culpa error incidunt pariatur voluptatibus at temporibus corrupti vel cupiditate illo ullam, facere quibusdam. Fuga architecto esse, nihil qui quibusdam illum iusto doloremque enim alias delectus voluptas temporibus maiores dolor culpa odio quasi perspiciatis. Rerum totam repudiandae velit illo. Laudantium non dolorem veniam numquam eligendi accusantium ratione distinctio rem, aperiam vero, error quas ipsa dignissimos nihil ullam dolores aliquam atque! Doloremque, eius laboriosam cumque totam, doloribus commodi nostrum voluptates exercitationem veniam facilis hic accusantium, saepe eaque.</NavLink>
      </div>
    </div>
  )
}